import { render, staticRenderFns } from "./ElegiacCouplet.vue?vue&type=template&id=55914bd1&scoped=true&"
import script from "./ElegiacCouplet.vue?vue&type=script&lang=js&"
export * from "./ElegiacCouplet.vue?vue&type=script&lang=js&"
import style0 from "./ElegiacCouplet.vue?vue&type=style&index=0&id=55914bd1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55914bd1",
  null
  
)

export default component.exports